<div class="flex items-center justify-center dialog-header ">
    {{formAction}} Contact

    <div class="absolute right-2">
        <button (click)="handleCloseDialog()" class="outline-none p-5">
            <i class="pi pi-times"></i>
        </button>
    </div>
</div>

<div class="dialog-content">
    <div class="p-4">
        <form #contactForm="ngForm" (ngSubmit)="onSubmit(contactForm.form.valid)">

            <div class="grid grid-cols-1 md:grid-cols-3 gap-6">
                <div *ngIf="isFixedColumn" class="col-span-1">
                    <label class="block mb-2">Prefix</label>
                    <p-select class="w-full" appendTo="body" [(ngModel)]="createFieldFormValue['prefix']" name="prefix"
                        [options]="prefixOptions"></p-select>
                </div>

                <div *ngIf="isFixedColumn" class="col-span-1">
                    <label class="block mb-2 requiredValue">First Name</label>
                    <input pInputText class="w-full" style="box-shadow: none !important;" #first_name="ngModel"
                        pattern="^[a-zA-Z0-9 ]*$" [(ngModel)]="createFieldFormValue['first_name']" name="first_name"
                        required
                        [ngClass]="{'ng-invalid ng-dirty' : isSubmitted && !createFieldFormValue['first_name']}" />
                    <small class="text-red-500" *ngIf="isSubmitted && !createFieldFormValue['first_name']">Enter First
                        Name</small>
                    <small class="text-red-500" *ngIf="first_name?.errors?.['pattern']">
                        Special characters are not allowed.
                    </small>
                </div>

                <div *ngIf="isFixedColumn" class="col-span-1">
                    <label class="block mb-2">Middle Name</label>
                    <input pInputText class="w-full" style="box-shadow: none !important;" #middle_name="ngModel"
                        pattern="^[a-zA-Z0-9 ]*$" [(ngModel)]="createFieldFormValue['middle_name']" name="middle_name" />
                    <small class="text-red-500" *ngIf="middle_name?.errors?.['pattern']">
                        Special characters are not allowed.
                    </small>
                </div>

                <div *ngIf="isFixedColumn" class="col-span-1">
                    <label class="block mb-2 requiredValue">Last Name</label>
                    <input pInputText class="w-full" style="box-shadow: none !important;"
                        [(ngModel)]="createFieldFormValue['last_name']" name="last_name" required #last_name="ngModel"
                        pattern="^[a-zA-Z0-9 ]*$"
                        [ngClass]="{'ng-invalid ng-dirty' : isSubmitted && !createFieldFormValue['last_name'] }" />
                    <small class="text-red-500" *ngIf="isSubmitted && !createFieldFormValue['last_name']">Enter Last
                        Name</small>
                    <small class="text-red-500" *ngIf="last_name?.errors?.['pattern']">
                        Special characters are not allowed.
                    </small>
                </div>

                <div *ngIf="isFixedColumn" class="col-span-1">
                    <label class="block mb-2 requiredValue">Contact Email</label>
                    <input pInputText class="w-full" style="box-shadow: none !important;"
                        [(ngModel)]="createFieldFormValue['email']" name="email" required
                        [ngClass]="{'ng-invalid ng-dirty' : isSubmitted && !createFieldFormValue['email']}" />
                    <small class="text-red-500" *ngIf="isSubmitted && !createFieldFormValue['email']">Enter Contact
                        Email</small>
                </div>

                <div *ngIf="isFixedColumn" class="col-span-1">
                    <label class="block mb-2 requiredValue">Contact Number</label>
                    <input pInputText type="number" class="w-full" style="box-shadow: none !important;"
                        [ngClass]="{'ng-invalid ng-dirty' : isSubmitted && !createFieldFormValue['contact_phone'] }"
                        [(ngModel)]="createFieldFormValue['contact_phone']" name="contact_phone" required />
                    <small class="text-red-500" *ngIf="isSubmitted && !createFieldFormValue['contact_phone']">Enter Contact Number</small>
                </div>

                <!-- <div *ngIf="isFixedColumn" class="col-span-1">
                    <label class="block mb-2">Alternate Number</label>
                    <input pInputText type="number" class="w-full" style="box-shadow: none !important;"
                        [(ngModel)]="createFieldFormValue['alternate_phone']" name="alternate_phone" />
                </div> -->

                <div *ngIf="isFixedColumn" class="col-span-1">
                    <label class="block mb-2 requiredValue">Designation</label>
                    <p-select class="w-full" appendTo="body" [(ngModel)]="createFieldFormValue['designation']"
                        name="designation" [options]="designationOptions" required
                        [ngClass]="{'ng-invalid ng-dirty' : isSubmitted && !createFieldFormValue['designation']}" />
                    <small class="text-red-500" *ngIf="isSubmitted && !createFieldFormValue['designation']">Select Designation</small>
                </div>

                <!-- <div *ngIf="isFixedColumn" class="col-span-1">
                    <label class="block mb-2">Date of Birth</label>
                    <p-datepicker class="w-full" appendTo="body" [inputStyle]="{
                        'box-shadow':'none !important',
                        'width': '100%'
                    }" [style]="{'box-shadow':'none !important',
                        'width': '100%'
                     }" 
                      [maxDate]="today"
                     [(ngModel)]="createFieldFormValue['date_of_birth']" name="date_of_birth" />
                </div> -->

                <!-- <div *ngIf="isFixedColumn" class="col-span-1">
                    <label class="block mb-2">Age</label>
                    <input pInputText class="w-full" style="box-shadow: none !important;"
                        [(ngModel)]="createFieldFormValue['age']" name="age" />
                </div> -->

                <div *ngIf="isFixedColumn" class="col-span-1">
                    <label class="block mb-2">Gender</label>
                    <p-select class="w-full" appendTo="body" [(ngModel)]="createFieldFormValue['gender']" name="gender"
                        [options]="genderOptions" />
                </div>

                <!-- <div *ngIf="isFixedColumn" class="col-span-1">
                    <label class="block mb-2">Nationality</label>
                    <input pInputText class="w-full" style="box-shadow: none !important;"
                        [(ngModel)]="createFieldFormValue['nationality']" name="nationality" />
                </div> -->

                <div *ngIf="isFixedColumn" class="col-span-1">
                    <label class="block mb-2">City</label>
                    <input pInputText class="w-full" style="box-shadow: none !important;"
                        [(ngModel)]="createFieldFormValue['city']" name="city" />
                </div>

                <div *ngIf="isFixedColumn" class="col-span-1">
                    <label class="block mb-2">State</label>
                    <input pInputText class="w-full" style="box-shadow: none !important;"
                        [(ngModel)]="createFieldFormValue['state']" name="state" />
                </div>

                <div *ngIf="isFixedColumn" class="col-span-1">
                    <label class="block mb-2">Country</label>
                    <input pInputText class="w-full" style="box-shadow: none !important;"
                        [(ngModel)]="createFieldFormValue['country']" name="country" />
                </div>

                <div *ngIf="isFixedColumn" class="col-span-1">
                    <label class="block mb-2">Postal Code</label>
                    <input pInputText class="w-full" style="box-shadow: none !important;"
                        [(ngModel)]="createFieldFormValue['postal_code']" name="postal_code" />
                </div>

                <div *ngIf="isFixedColumn" class="col-span-1">
                    <label class="block mb-2">Academic Year</label>
                    <p-select class="w-full" appendTo="body" [(ngModel)]="createFieldFormValue['academic_year_id']"
                        name="academic_year_id" [options]="academicYears" optionLabel="year_name" optionValue="id"
                        placeholder="Select Academic Year" [filter]="true"></p-select>
                </div>

                <div *ngIf="isFixedColumn" class="col-span-1">
                    <label class="block mb-2">Batch</label>
                    <p-select class="w-full" appendTo="body" [(ngModel)]="createFieldFormValue['batch_id']"
                        name="batch_id" [options]="batches" optionLabel="batch_name" optionValue="id"
                        placeholder="Select Batch" [filter]="true"></p-select>
                </div>

                <div *ngIf="isFixedColumn" class="col-span-1">
                    <label class="block mb-2">Course</label>
                    <p-select class="w-full" appendTo="body" [(ngModel)]="createFieldFormValue['course_id']"
                        name="course_id" [options]="courses" optionLabel="name" optionValue="course_id"
                        placeholder="Select Course" [filter]="true"></p-select>
                </div>

                <div *ngIf="isFixedColumn" class="col-span-1">
                    <label class="block mb-2">Department</label>
                    <p-select class="w-full" appendTo="body" [(ngModel)]="createFieldFormValue['department_id']"
                        name="department_id" [options]="departments" optionLabel="name" optionValue="dept_id"
                        placeholder="Select Department" [filter]="true"></p-select>
                </div>
            </div>

            <div class="grid grid-cols-1 mt-4">
                <div class="col-span-1">
                    <label class="block mb-2">Address Line 1</label>
                    <input pInputText class="w-full" style="box-shadow: none !important;"
                        [(ngModel)]="createFieldFormValue['address_line1']" name="address_line1" />
                </div>
            </div>

            <div class="grid grid-cols-1 mt-4">
                <div class="col-span-1">
                    <label class="block mb-2">Address Line 2</label>
                    <input pInputText class="w-full" style="box-shadow: none !important;"
                        [(ngModel)]="createFieldFormValue['address_line2']" name="address_line2" />
                </div>
            </div>

            <div class="grid grid-cols-1 mt-4">
                <div class="col-span-1">
                    <label class="block mb-2">Remarks</label>
                    <textarea pTextarea class="w-full" rows="5" style="box-shadow: none !important;"
                        [(ngModel)]="createFieldFormValue['remarks']" name="remarks"></textarea>
                </div>
            </div>

            <div class="grid grid-cols-1 md:grid-cols-3 gap-6 mt-4">
                <div class="" *ngFor="let item of allContactFields">
                    <div class="col-span-1 w-full">
                        <label class="block mb-2" [ngClass]="{ 'requiredValue': item.required }">{{ item.label }}</label>
                        <input pInputText *ngIf="item.type !== 'select' && item.type !== 'textarea'" class="w-full"
                            [(ngModel)]="fieldValues[item.field_name]" name="{{ item.field_name }}"
                            style="box-shadow: none !important;" [required]="item.required === true ? true : false "
                            [ngModelOptions]="{ standalone: false }"
                            placeholder="{{ item.placeholder }}" [ngClass]="{
                    'ng-invalid ng-dirty' : isSubmitted && item.required && !fieldValues[item.field_name]
                }" />
                        <textarea pTextarea *ngIf="item.type === 'textarea'" style="box-shadow: none !important;"
                            class="w-full" [(ngModel)]="fieldValues[item.field_name]" name="{{ item.field_name }}"
                            [ngModelOptions]="{ standalone: false }"
                            [required]="item.required === true ? true : false "
                            placeholder="{{ item.placeholder }}"></textarea>
                        <p-select *ngIf="item.type === 'select'" class="w-full" appendTo="body"
                        [ngModelOptions]="{ standalone: false }"
                            [required]="item.required === true ? true : false "
                            [(ngModel)]="fieldValues[item.field_name]" name="{{ item.field_name }}"
                            [options]="item.data" [placeholder]="item.placeholder"></p-select>
                        <small class="text-red-500"
                            *ngIf="isSubmitted && item.required && !fieldValues[item.field_name]">Enter {{ item.label
                            }}</small>
                    </div>
                </div>
            </div>

            <div class="mt-4">
                <p-button [label]="formAction === 'Add' ? 'Save' : 'Update'"
                    [icon]="formAction === 'Add' ? 'pi pi-save' : 'pi pi-pencil'" [disabled]="isLoading"
                    [loading]="isLoading"
                    type="submit"
                    class="p-button-primary w-full md:w-auto"></p-button>
            </div>
        </form>
    </div>
</div>
